export var defaults = {
    ignore: []
};
export var normalize = function (options) {
    return Object.assign({}, defaults, options);
};
